export default {
      id: "passcode-usage",
      viewBox: "0 0 26 26",
      url: __webpack_public_path__ + "img/icons.f759dcb6.svg#passcode",
      toString: function () {
        return this.url;
      }
    }